import { useAccountContext } from '@seek/hirer-graphql-react';
import { useTranslations } from '@vocab/react';
import { Stack, Actions, Text, Button } from 'braid-design-system';
import type React from 'react';

import { useMutateDeleteDraftJob } from 'src/hooks/useMutateDeleteDraftJob';

import translations from '../.vocab';

interface DeleteDraftJobDialogContentProps {
  draftId: string;
  onClose(): void;
  onSuccess(): void;
}

export const DeleteDraftJobDialogContent: React.FC<
  React.PropsWithChildren<DeleteDraftJobDialogContentProps>
> = ({ draftId, onClose, onSuccess }) => {
  const { accountContext } = useAccountContext();
  const { t } = useTranslations(translations);

  const { deleteDraftJob, loading, error } = useMutateDeleteDraftJob(draftId);

  const onDelete = async () => {
    if (accountContext?.currentAdvertiser?.permissionOptions.canCreateJobs) {
      try {
        await deleteDraftJob();
        onSuccess();
      } catch {
        // use error from useMutation
      }
    }
  };

  return (
    <Stack space="gutter">
      {error && (
        <Text tone="critical" size="standard">
          {t('The Draft job cannot be deleted')}
        </Text>
      )}
      <Actions>
        <Button
          onClick={onDelete}
          loading={loading}
          data={{ testid: 'deleteDraftJobSubmitButton' }}
        >
          {t('Yes')}
        </Button>
        <Button variant="transparent" onClick={onClose}>
          {t('No')}
        </Button>
      </Actions>
    </Stack>
  );
};
